const isForRfp = (bidder, rfpId) => `${bidder.requestForProposalId}` === `${rfpId}`;

// The bid a notification link (.../supplier/:supplierFacilityId/bid) points at, among this RFP's loaded bidders.
export const findLinkedBid = (bidders, rfpId, supplierFacilityId) =>
	bidders.find(
		(bidder) =>
			isForRfp(bidder, rfpId) &&
			`${bidder.supplierFacilityId}` === `${supplierFacilityId}` &&
			!!bidder.proposalId
	);

// Only a bidder fetch this page saw finish can rule the bid out; earlier data may be another RFP's.
export const isLinkedBidMissing = (bidderFetchSeen, supplierFacilityId, linkedBid) =>
	bidderFetchSeen && !!supplierFacilityId && !linkedBid;
